<template>
  <div class="episode-list-tabbed">
    <v-tabs v-model="tab" align-tabs="left">
      <v-tab :ripple="false" class="tab-flix" :value="0"><h2>{{
        $t("detail_page.episodes")
        }}</h2></v-tab>
      <v-tab
        :ripple="false"
        class="tab-flix"
        v-for="(t, i) in assets"
        :value="i + 1"
        v-bind:key="i + 1"
        ><h2>{{ t.title }}</h2></v-tab
      >
    </v-tabs>
    <v-window v-model="tab">
      <v-window-item :value="0">
        <v-container fluid>
          <span class="text-gray-3 float-right"
            >{{ seasons[seasonSelected].episodes.length }}
            {{ $t("detail_page.episodes") }}</span
          >
          <v-menu open-on-hover>
            <template v-slot:activator="{ props }">
              <v-btn
                variant="outlined"
                v-bind="props"
                :ripple="false"
                class="text-capitalize mb-3"
              >
                {{ $t("detail_page.season") }}
                {{ seasons[seasonSelected].season }} <icon-arrow-down />
              </v-btn>
            </template>

            <v-list>
              <v-list-item v-for="(item, index) in seasons" :key="index">
                <v-list-item-title @click="seasonSelected = index"
                  >Season {{ item.season }}</v-list-item-title
                >
              </v-list-item>
            </v-list>
          </v-menu>

          <div class="row">
            <episode-card
              class="col-md-4"
              v-for="(episode, index) in paginated(
                seasons[seasonSelected].episodes
              )"
              :key="index"
              :episode="episode"
              :position="index"
              :img-alt="
                $t('detail_page.watch_episode_alt', {
                  episode: episode.title,
                  show: title,
                  season: episode.season,
                })
              "
              :slug="slug"
            />
          </div>
          <div class="text-center">
            <v-container>
              <v-row justify="center">
                <v-col cols="12">
                  <v-container class="max-width paginator">
                    <v-pagination
                      color="red"
                      :ripple="false"
                      prev-icon="chevron_left"
                      next-icon="chevron_right"
                      v-model="page"
                      class="my-4"
                      :length="totalEpisodes"
                    ></v-pagination>
                  </v-container>
                </v-col>
              </v-row>
            </v-container>
          </div>
        </v-container>
      </v-window-item>
      <v-window-item v-for="(t, n) in assets" :key="n + 1" :value="n + 1">
        <v-container fluid>
          <swiper
            :modules="modules"
            :slides-per-view="slidesPerView"
            :space-between="20"
            :pagination="false"
            navigation
            :scrollbar="false"
            @swiper="onSwiper"
            @slideChange="onSlideChange"
          >
            <swiper-slide v-for="(asset, i) in t.assets" v-bind:key="i">
              <flat-horizontal-card
                :asset="asset"
                :position="i"
                :img-alt="
                  asset.type === 'series'
                    ? $t('detail_page.stream_tv_shows', {
                        title: asset.title,
                      })
                    : $t('detail_page.watch_and_stream_movies', {
                        movie: asset.title,
                      })
                "
              />
            </swiper-slide>
          </swiper>
        </v-container>
      </v-window-item>
    </v-window>
  </div>
</template>

<script>
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from "swiper/vue";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import VerticalCard from "@/components/landing/carousel/VerticalCard.vue";
import HorizontalCard from "@/components/landing/carousel/HorizontalCard.vue";
import FlatHorizontalCard from "@/components/landing/carousel/FlatHorizontalCard.vue";
import IconArrowDown from "@/components/icons/iconArrowDown.vue";
import EpisodeCard from "@/components/landing/carousel/EpisodeCard.vue";
import { A11y, Navigation, Pagination, Scrollbar } from "swiper";

export default {
  name: "TabbedEpisodes",
  components: {
    EpisodeCard,
    IconArrowDown,
    FlatHorizontalCard,
    Swiper,
    SwiperSlide,
  },
  props: {
    seasons: {
      type: Array,
      required: true,
    },
    assets: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: false,
      default: "",
    },
    slug: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    tab: null,
    seasonSelected: 0,
    page: 1,
    total: 6,
  }),
  computed: {
    slidesPerView() {
      if (this.isMobile()) {
        return 1.3;
      } else {
        return 4.3;
      }
    },
    totalEpisodes() {
      let episodeCount = this.seasons[this.seasonSelected].episodes.length;
      return Math.ceil(episodeCount / this.total);
    },
  },
  methods: {
    paginated(items) {
      return items.slice((this.page - 1) * this.total, this.total * this.page);
    },
  },
  setup() {
    const onSwiper = (swiper) => {
      // console.log(swiper);
    };
    const onSlideChange = () => {
      console.log("slide change");
    };
    return {
      onSwiper,
      onSlideChange,
      modules: [Navigation, Pagination, Scrollbar, A11y],
    };
  },
};
</script>

<style lang="scss">
@import "src/assets/scss/colors";
.episode-list-tabbed {
  .v-btn__overlay {
    background: none !important;
  }
  .chevron_right {
    background: url("@/assets/img/episodes/chevron-right.svg") no-repeat center
      center !important;
  }
  .chevron_left {
    background: url("@/assets/img/episodes/chevron-left.svg") no-repeat center
      center !important;
  }
  .paginator {
    .v-btn.v-btn--density-default {
      height: 2.5em !important;
    }
    .v-pagination__item--is-active {
      .v-btn {
        background: $red !important;
        border: 1px solid $red;
      }
    }
    .v-btn {
      padding: 0.5em;
      width: 2.5em;
      height: 2.5em;
      border: 1px solid #233452;
      background: linear-gradient(
        1.64deg,
        #202b40 -6.14%,
        rgba(12, 17, 26, 0) 160.73%
      );
      border-radius: 5px !important;
      &:hover {
        background: $red !important;
        border: 1px solid $red;
        .v-btn__overlay {
          display: none !important;
        }
      }
      .v-btn__overlay {
        display: none;
      }
    }
  }

  .v-tab--selected {
    .v-tab__slider {
      background: $red !important;
    }
  }

  .tab-flix {
    &:after {
      content: none !important;
    }
    .v-btn__overlay {
      display: none !important;
      opacity: 0;
    }

    .v-btn__content > h2 {
      font-size: 0.875rem;
    }

    .v-btn__underlay {
      display: none !important;
    }
    &.v-btn {
      padding: 0 !important;

      background: none;
      border: none;
      &.v-btn--density-default {
        height: 2.8em !important;
        padding: 0em 3em !important;
        margin: 0 1em;
      }

      &.v-slide-group-item--active {
        background: none !important;
      }
    }
  }
}
</style>
